import { Field as Fieldmik, Form as Formiker, withFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";

import { Button, Container, Dropdown, Form as FormUi, Modal } from 'semantic-ui-react';

import Axios from 'axios';
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  errorAlertDispatcher,
  infoAlertDispatcher, successAlertDispatcher,
  warningAlertDispatcher
} from "../../redux/actions/alertAction";
import { AllRegex } from "../../utils/validation";
import CreatAxios from "../axiosComponent/create";
import { MyNormalCheckBox } from "../dynamicComponent/myInputs";
import {
  FIELD_IS_REQUIRED, INVALID_EMAIL,
  INVALID_MOBILE_NO, INVALID_NAME, INVALID_PAN_NUMBER
} from "../../utils/validationConstant";


const AddVendorDynamically = ({ values, touched, errors, handleSubmit, t, editData, usersList, action, setFieldValue }) => {
  const [open, setOpen] = useState(false)
  const [vendorCategoryList, setVendorCategoryList] = useState([]);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('isloggedIn');
    const customerNo = Number(localStorage.getItem('customerNumber'));

    Axios.get(`${process.env.REACT_APP_MASTER_API}/vendorType/0`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token
      },
      params: {
        customerNo: customerNo,
        userId: userId
      }
    }).then((response => {
      let options = [];
      response.data.resultSet.map((object, index) => {
        let temp = {}
        temp.key = object.vendorTypeId
        temp.text = object.vendorType
        temp.value = object.vendorTypeId
        temp.id = object.vendorTypeId
        return options[index] = temp
      })
      setVendorCategoryList(options);
    }))
      .catch(error => {
        console.log("🚀 ~ file: addVendorDynamically.js ~ line 59 ~ useEffect ~ error", error)
      })
  }, []);

  const handleSubmited = () => {
    if (
      AllRegex.Name.test(values.transporterName)
    ) {
      handleSubmit();
      setOpen(false);
    } else {
    }
  };

  const handleClose = () => {
    setOpen(false);
  }

  const customerNo = localStorage.getItem('customerNumber')


  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={<Button className="ui icon create-consignee_button padding-tb-10"><i aria-hidden="true" className="add icon"></i></Button>}
    >
      <Modal.Header>
        {t(customerNo == 1158 ? "add_title" : "add_vendor_title") || "New Vendor"}
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <React.Fragment>
            <Formiker>
              <div className="m-3 pl-3">
                <div className="ui form">
                  <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t(customerNo != 1158 ? "vendor_code.vendor_title" : "vendor_code.title") || "Vendor Code"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                    // error={
                    //   touched.transporterCode && errors.transporterCode
                    //     ? true
                    //     : false
                    // }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        disabled={editData?.transporterCode ? true : false}
                        name="transporterCode"
                        placeholder={t("vendor_code.placeholder") || "Type Code"}
                      />
                      {/* {touched.transporterCode && errors.transporterCode ? (
                    <div>
                      {t(`vendor_code.error_msg.${errors.transporterCode}`) ||
                        errors.transporterCode}
                    </div>
                  ) : null} */}
                    </FormUi.Field>
                    <FormUi.Field width={2}></FormUi.Field>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t(customerNo != 1158 ? "vendor_name.vendor_title" : "vendor_name.title") || "Vendor Company Name"} *{" "}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={
                        touched.transporterName && errors.transporterName
                          ? true
                          : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="transporterName"
                        placeholder={t("vendor_name.placeholder") || "Type Name"}
                      />
                      {touched.transporterName && errors.transporterName ? (
                        <div>
                          {t(`vendor_name.error_msg.${errors.transporterName}`) ||
                            errors.transporterName}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("contact_person_name.title") || "Contact Person Name"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={
                        touched.transporterContactPerson &&
                          errors.transporterContactPerson
                          ? true
                          : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="transporterContactPerson"
                        placeholder={
                          t("contact_person_name.placeholder") ||
                          "Enter Contact Person Name"
                        }
                      />
                      {touched.transporterContactPerson &&
                        errors.transporterContactPerson ? (
                        <div>
                          {t(
                            `contact_person_name.error_msg.${errors.transporterContactPerson}`
                          ) || errors.transporterContactPerson}
                        </div>
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={2}></FormUi.Field>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t(`contact_person_number.title`) || "Contact Person Number"}{" "}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={
                        touched.transporterContactPersonNumber &&
                          errors.transporterContactPersonNumber
                          ? true
                          : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="transporterContactPersonNumber"
                        placeholder={
                          t("contact_person_number.placeholder") ||
                          "Enter Contact Person Number"
                        }
                      />
                      {touched.transporterContactPersonNumber &&
                        errors.transporterContactPersonNumber ? (
                        <div>
                          {t(
                            `contact_person_number.error_msg.${errors.transporterContactPersonNumber}`
                          ) || errors.transporterContactPersonNumber}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t(customerNo != 1158 ? "company_address.vendor_title" : "company_address.title") || "Company Address"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={
                        touched.companyAddress && errors.companyAddress ? true : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="companyAddress"
                        placeholder={
                          t("company_address.placeholder") || "Enter Company Address"
                        }
                      />
                      {touched.companyAddress && errors.companyAddress ? (
                        <div>
                          {t(`company_address.error_msg.${errors.companyAddress}`) ||
                            errors.companyAddress}
                        </div>
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={2}></FormUi.Field>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t(`pincode.title`) || "Pincode"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={
                        touched.companyPincode && errors.companyPincode ? true : false
                      }
                    >
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="companyPincode"
                        placeholder={t("pincode.placeholder") || "Enter Pincode"}
                      />
                      {touched.companyPincode && errors.companyPincode ? (
                        <div>
                          {t(`pincode.error_msg.${errors.companyPincode}`) ||
                            errors.companyPincode}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t("pan_no.title") || "Pan No."}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={4}>
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="companyPan"
                        placeholder={t("pan_no.placeholder") || "Pan No."}
                      />
                      {touched.companyPan && errors.companyPan ? (
                        <div>
                          {t(`pan_no.error_msg.${errors.companyPan}`) || errors.companyPan}
                        </div>
                      ) : null}
                      {/* <Checkbox label={t("gst_no.action.na") || "N/A"} /> */}
                    </FormUi.Field>
                    <FormUi.Field width={2}></FormUi.Field>

                    <FormUi.Field width={2}>
                      <label className="labelName">
                        {t(customerNo != 1158 ? 'user_vendor_email.title_alt' : "user_vendor_email.title") || "Email Id"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={4} className="display-grid-center-imp">
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="transporterEmail"
                        placeholder={t(customerNo != 1158 ? 'user_vendor_email.title_alt' : "user_vendor_email.title") || "Email Id"}
                      // error={touched.transporterEmail && errors.transporterEmail ? true : false}

                      />
                      {/* <Checkbox label={t("email_id.action.title") || "Alerts"} /> */}
                      {/* {touched.transporterEmail && errors.transporterEmail ? (
                    <div className="error-msg">
                      {t(`user_vendor_email.error_msg.${errors.transporterEmail}`) || errors.transporterEmail}
                    </div>
                  ) : null} */}
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group inline>
                    <FormUi.Field width={2}>
                      <label>Vendor Type</label>
                    </FormUi.Field>
                    <FormUi.Field width={4}>
                      <Dropdown
                        name="vendorTypeId"
                        clearable
                        style={{ width: "100%", fontWeight: "normal" }}
                        selection
                        placeholder="Please select Vendor Type"
                        value={values.vendorTypeId}
                        options={vendorCategoryList}
                        onChange={(name, data) => {
                          setFieldValue("vendorTypeId", data.value);
                        }}
                      />
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group inline>
                    <FormUi.Field>
                      <Fieldmik className="mt-4" component={MyNormalCheckBox} checked={values.vendorOwnershipType == 1 ? true : false} label={t(customerNo != 1158 ? "self_vendor.vendor_title" : "self_vendor.title") || "Is Self Vendor"} name="vendorOwnershipType" />

                    </FormUi.Field>
                  </FormUi.Group>
                </div>
              </div>

              <Container className="p-3" textAlign="center">
                <button
                  className="w3-button w3-blue w3-hover-blue w3-round w3-small"
                  type="submit"
                  onClick={handleSubmited}
                >
                  {t("action_button.submit") || "Submit"}
                </button>
                <button
                  className="w3-button w3-blue w3-hover-blue w3-round w3-small ml-5"
                  onClick={handleClose}
                >
                  {t("action_button.cancel") || "Cancel"}
                </button>
              </Container>
            </Formiker>
          </React.Fragment>
        </Modal.Description>
      </Modal.Content>

    </Modal>
  )
}

const FormikAddVendor = withFormik({
  validationSchema: yup.object({
    transporterCode: yup.string().optional(),
    transporterName: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_NAME),
    transporterContactPerson: yup.string().optional().matches(AllRegex.Name, INVALID_NAME),
    transporterContactPersonNumber: yup.string().optional().matches(AllRegex.MobileNumber, INVALID_MOBILE_NO),
    companyPan: yup.string().optional().matches(AllRegex.PANIN, INVALID_PAN_NUMBER),
    transporterEmail: yup.string().email("email").optional().matches(AllRegex.Email, INVALID_EMAIL),
    vendorTypeId: yup.mixed().optional(),
    // companyAddress: yup.string().required("required").matches(AllRegex.Address, "address"),
    // companyPincode: yup.string().required("required"),
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    transporterCode: "",
    transporterName: "",
    transporterContactPerson: "",
    transporterContactPersonNumber: "",
    vendorOwnershipType: "",
    companyAddress: "",
    companyPincode: "",
    companyPan: "",
    transporterEmail: "",
    vendorTypeId: null,
    existingVendorType: null
  }),
  async handleSubmit(values, { props }) {
    const combine = {
      ...values,
      vendorTypeId: values.existingVendorType !== '' && values.vendorTypeId === '' ? ' ' : values.vendorTypeId,
      vendorOwnershipType: values.vendorOwnershipType === true ? '1' : '0'
    }
    await CreatAxios({
      url: "transporterMaster",
      payload: { ...combine },
    })
      .then((res) => {
        let alert;
        if (res?.data?.status == 200) {
          alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: res?.data?.message ? res.data.message : "New vendor is created.",
          };
          props.successAlertDispatcher(alert);
        } else {
          alert = {
            type: "warning",
            messageHeader: "Warning",
            messageBody: res?.data?.message ? res.data.message : "New vendor is created.",
          };
          props.successAlertDispatcher(alert);
        }
      })
      .catch((err) => {
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: "Unable to create new vendor.",
        };
        props.errorAlertDispatcher(alert);
      });
  },
})(AddVendorDynamically);

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate("create_vendor")(FormikAddVendor));
